import { IRecordCode } from './record-code.type';

export type ISchool = IRecordCode;

export enum ISchoolCode {
  eib = 'eib',
  csa = 'csa',
  hac = 'hac',
}
